import React from 'react';
import { Link } from 'react-router-dom';


function GoodBlock(props) {


return (
  <>
    <div data-course-id="91" id="course_91" class="box_section-item">
                          <div class="item_img">
                            <div>
                              {/* <div class="bookmark">
                                <span>
                                  <i class="fa-bookmark far"></i>
                                </span>
                              </div>  */}
                          
                              </div> 
                              {/* <div data-v-77a1be83="" class="vip_course">
                                <span data-v-77a1be83="">
                                  <i data-v-77a1be83="" class="fa-stars fas"></i>
                                </span></div>  */}
                                <Link to={props.pageUrl}>
                                <img src={props.imageAddress} alt={props.title}/>
                                </Link>
                              </div> 
                              <div class="item_main">
                                <div class="item_content">
                                  <h2 class="title">
                             <Link to={props.pageUrl}>
                               <span>{props.title}</span>
                               </Link>
                                  </h2> 
                                  <p class="description">
                                  {props.description}
                                  </p>
                            
                                </div>
                                {/* <div class="is_vip_course">
                                  <span class="icon fas fa-star"></span>
                                  دسترسی رایگان برای اعضای ویژه
                                </div>  */}
                                <div class="item_footer">
                                  {/* <div class="i tem_footer-info">
                                    <span class="course_time">۰۴:۳۴:۴۲ 
                                      <i aria-hidden="true" class="far fa-clock"></i>
                                    </span> <div class="likes">
                                    <span>۶</span> 
                                    <i class="fa-heart far"></i>
                                  </div>
                                </div>  */}
                                <span class="course_price">
                                {props.price}
                                  </span>
                              </div>
                            </div>
                          </div> 
  </>
) 
}

export default GoodBlock;